app.controller('CheckoutDetailsController', [
  '$scope',
  'Config',
  '$timeout',
  'cart',
  'toaster',
  'product',
  'CacheFactory',
  'quote',
  '$rootScope',
  '$window',
  '$location',
  '$anchorScroll',
  'setting',
  'helper',
  function ($scope, Config, $timeout, cart, toaster, product, CacheFactory, quote, $rootScope, $window, $location, $anchorScroll, setting, helper) {

    $scope.cart = cart.getCart();
    $scope.base_url = Config.base_url;
    $scope.cartService = cart;

    $scope.sameTransportDates = false;
    $scope.insideWorkingHours = Config.insideWorkingHours;
    $scope.outsideWorkingHours = Config.outsideWorkingHours;
    $scope.timeslots = [...$scope.insideWorkingHours, ...$scope.outsideWorkingHours];
    $scope.transport = {
      delivery: {
        option: null,
        actual_timeslots: $scope.insideWorkingHours,
        timeSlots: [],
        timeStart: null,
        timeEnd: null
      },
      collection: {
        option: null,
        actual_timeslots: $scope.insideWorkingHours,
        timeSlots: [],
        timeStart: null,
        timeEnd: null
      }
    }
    $scope.surcharges = null;
    $scope.retrievedQuote = false;
    $scope.details = {
      name: (CacheFactory.get('appCache').get('quote')) ? CacheFactory.get('appCache').get('quote').name : '',
      telephone: (CacheFactory.get('appCache').get('quote')) ? CacheFactory.get('appCache').get('quote').telephone : '',
      company: (CacheFactory.get('appCache').get('quote')) ? CacheFactory.get('appCache').get('quote').company : '',
      email: (CacheFactory.get('appCache').get('quote')) ? CacheFactory.get('appCache').get('quote').email : '',
      deliveryPostcode: (CacheFactory.get('appCache').get('quote')) ? CacheFactory.get('appCache').get('quote').deliveryPostcode : '',
      collectionPostcode: (CacheFactory.get('appCache').get('quote')) ? CacheFactory.get('appCache').get('quote').collectionPostcode : '',
      deliveryDate: (CacheFactory.get('appCache').get('deliveryDate')) ? moment(CacheFactory.get('appCache').get('deliveryDate')).toDate() : moment().add(1, 'days').toDate(),
      collectionDate: (CacheFactory.get('appCache').get('collectionDate')) ? moment(CacheFactory.get('appCache').get('collectionDate')).toDate() : moment().add(8, 'days').toDate(),
      deliveryDateOpened: false,
      collectionDateOpened: false,
      hireDays: (CacheFactory.get('appCache').get('hireDays')) ? CacheFactory.get('appCache').get('hireDays') : 8,
      hireWeeks: (CacheFactory.get('appCache').get('hireWeeks')) ? CacheFactory.get('appCache').get('hireWeeks') : 1,
      deliveryDateOptions: {
        minDate: moment().add(1, 'days').toDate(),
        startingDay: 1
      },
      collectionDateOptions: {
        minDate: moment().add(2, 'days').toDate(),
        startingDay: 1
      },
      limitations: ''
    }


    $scope.init = function () {
      //get brand setting

      setting.get().then(function (response) {
        var hour;
        setting.getTime().then(function (resp) {
          hour = resp.data.hour_24;
          if (hour >= parseInt(response.data.global.cutoff_time)) {
            $scope.details.deliveryDateOptions.minDate = moment(resp.data.datetime).add(parseInt(response.data.global.min_date_offset_after), 'days').toDate();
            $scope.details.deliveryDate = $scope.details.deliveryDateOptions.minDate;
            $scope.details.collectionDateOptions.minDate = moment(resp.data.datetime).add(parseInt(response.data.global.min_date_offset_after) + 0, 'days').toDate();
          } else {
            $scope.details.deliveryDateOptions.minDate = moment(resp.data.datetime).add(parseInt(response.data.global.min_date_offset_before), 'days').toDate();
            $scope.details.collectionDateOptions.minDate = moment(resp.data.datetime).add(parseInt(response.data.global.min_date_offset_before) + 0, 'days').toDate();
          }
        });

        $scope.checkHirePeriod();

      }, function (response) {

      });
      $scope.checkHirePeriod();

    }

    $scope.copyPostcode = function (event) {
      $scope.details.collectionPostcode = $scope.details.deliveryPostcode;
      $scope.getSurcharges();
    }

    $scope.setCol = function () {
      $scope.details.collectionDate = new Date($scope.details.deliveryDate.getFullYear(), $scope.details.deliveryDate.getMonth(), $scope.details.deliveryDate.getDate());
      $scope.details.collectionDate = moment($scope.details.collectionDate).add(1, 'days').toDate();
      $scope.details.collectionDateOptions.minDate = $scope.details.deliveryDate;
      $scope.details.collectionDateOpened = true;
      $scope.setHirePeriod();
    }

    $scope.setHirePeriod = function () {

      deliveryDate = new Date($scope.details.deliveryDate.getFullYear(), $scope.details.deliveryDate.getMonth(), $scope.details.deliveryDate.getDate());
      collectionDate = new Date($scope.details.collectionDate.getFullYear(), $scope.details.collectionDate.getMonth(), $scope.details.collectionDate.getDate());
      $scope.details.hireDays = helper.hireDays(deliveryDate, collectionDate);

      if ($scope.details.hireDays == 1) {
        $scope.details.hireWeeks = 1;
      } else {
        $scope.details.hireWeeks = Math.round(($scope.details.hireDays / 7) + 0.35);
      }
      CacheFactory.get('appCache').put('hireDays', $scope.details.hireDays);
      CacheFactory.get('appCache').put('hireWeeks', $scope.details.hireWeeks);
      CacheFactory.get('appCache').put('deliveryDate', moment($scope.details.deliveryDate).utc());
      CacheFactory.get('appCache').put('collectionDate', moment($scope.details.collectionDate).utc());
      $scope.cartService.updateCart();
    }

    $scope.open = function (field) {
      if (field == 'col') {
        $scope.details.collectionDateOpened = true;
      } else {
        $scope.details.deliveryDateOpened = true;
      }
    }

    $scope.remove = function (idx) {
      var product_name = $scope.cart.content[idx].data.product_name;
      cart.remove(idx);
      toaster.pop('success', "Quote Updated!", product_name + ' removed successfully from quote!');
    }

    $scope.getQuote = function (form) {

      $scope.details.limitations = '';

      var content = angular.copy($scope.cart.content);

      //go through cart and add the full link for product images
      angular.forEach(content, function (item, key) {
        item.data.image = item.data.cart_image;
      });

      if (form.$valid) {
        $rootScope.load = true;

        data = {
          'brand': Config.brand_key,
          'delivery-postcode': $scope.details.deliveryPostcode,
          'collection-postcode': $scope.details.collectionPostcode,
          'cart-total-weight': cart.totalWeight(),
          'product-total': cart.getCart().totals.productTotal,
          'company': $scope.details.company,
          'name': $scope.details.name,
          'email': $scope.details.email,
          'telephone': $scope.details.telephone,
          'hire-days': $scope.details.hireDays,
          'user-agent': angular.element('#user_agent').val(),
          'user-ip': angular.element('#user_ip').val(),
          'token': angular.element('#user_token').val(),
          'delivery-date-timestamp': moment($scope.details.deliveryDate).utc().unix(),
          'collection-date-timestamp': moment($scope.details.collectionDate).utc().unix(),
          'cart': content
        };

        //check for applied discount codes
        if (angular.isDefined(CacheFactory.get('appCache').get('quote'))) {
          if (angular.isDefined(CacheFactory.get('appCache').get('quote').discountCode)) {
            data['discount-code'] = CacheFactory.get('appCache').get('quote').discountCode;
          }
        }

        if ($('#utm_source').val() != '') {
          data['utm_source'] = $('#utm_source').val();
        }

        if ($('#utm_medium').val() != '') {
          data['utm_medium'] = $('#utm_medium').val();
        }

        if ($('#utm_campaign').val() != '') {
          data['utm_campaign'] = $('#utm_campaign').val();
        }

        if ($('#camefrom').val() != '') {
          data['camefrom'] = $('#camefrom').val();
        }

        if($scope.sameTransportDates){
          data['delivery-date'] = moment($scope.details.deliveryDate).format('DD/MM/YYYY');
          data['collection-date'] = moment($scope.details.collectionDate).format('DD/MM/YYYY');
          data['transport_data'] = $scope.transport;
        }

        //get the delivery and collection timestamps
        quote.get(data).then(function (response) {
          var dataObj = response.data;
          if (typeof dataObj.code === 'undefined') {
            $scope.cart.cartChanged = false;
            CacheFactory.get("appCache").put("cart", $scope.cart);
            CacheFactory.get('appCache').put('quote', response.data);
            if($scope.sameTransportDates){
              CacheFactory.get("appCache").put("details_transport", response.data.transport_data);
            }
            else {
              CacheFactory.get("appCache").remove("details_transport");
            }
            //redirect to the quote page
            $window.location.href = $scope.base_url + 'checkout/quote';
          }
        }, function (response) {
          if (response.status == 406) {
            //then there are some limitations
            $scope.details.limitations = response.data.limitations.message;
            $rootScope.load = false;
          }
        });
      } else {
        // scroll up to the details section
        $location.hash('detailsForm');
        $anchorScroll();
      }
    }

    $scope.openWeeklyDiscountPopup = function () {
      $('#weeklyDiscountModal').modal('show');
    }

    $scope.getSurcharges = async function(force = false) {
      if ($scope.surcharges == null || force) {
        const data = {
          brand: Config.brand_key,
          deliveryPostcode: $scope.details.deliveryPostcode,
          collectionPostcode: $scope.details.deliveryPostcode
        };
        
        try {
          const response = await quote.getSurcharges(data);
          $scope.surcharges = response.data;
  
          if(force){
            $scope.setTimeslots('delivery', $scope.surcharges);
            $scope.setTimeslots('collection', $scope.surcharges);
          }
          return response.data;
        } catch (error) {
          console.log(error);
          return null; 
        }
      }
    };
  
    $scope.handleSurcharges = function() {
      $scope.getSurcharges(true);
    }
  
    $scope.checkHirePeriod = async function() {
      var surcharges = await $scope.getSurcharges();
      if($scope.details.deliveryDate != "" && $scope.details.collectionDate != "") {
          if(angular.isDefined(CacheFactory.get('appCache').get('details_transport'))){
            $scope.transport = CacheFactory.get('appCache').get('details_transport');
            $scope.setTimeslots('delivery', $scope.surcharges, false);
            $scope.setTimeslots('collection', $scope.surcharges, false);
          }
          else {
            $scope.setTimeslots('delivery', $scope.surcharges);
            $scope.setTimeslots('collection', $scope.surcharges);
          }
  
          $scope.sameTransportDates = false;
          if(moment($scope.details.deliveryDate).format('DD/MM/YYYY') == moment($scope.details.collectionDate).format('DD/MM/YYYY')){
            $scope.sameTransportDates = true;
          }
        }
        return $scope.sameTransportDates;
    }
  
    $scope.getEndSlot = function(type, val){
      $scope.setTimeslots(type, $scope.surcharges, false);
    }
  
    $scope.checkTransportDates = function() {
      $scope.sameTransportDates = false;
      if(moment($scope.details.deliveryDate).format('DD/MM/YYYY') == moment($scope.details.collectionDate).format('DD/MM/YYYY')){
        $scope.sameTransportDates = true;
      }
    }
  
    $scope.setTimeslots = function(type, surcharges, initial = true) {

      var code = type == 'delivery' ? 'DEL' : 'COL';
      var timeStartValue = null;
      if(initial){
        if(type == 'delivery'){
          $scope.transport[type].timeStart = '08:00';
        }
        else {
          $scope.transport[type].timeStart = '16:00';
        }
      }

      var inside = 'no';
      $scope.insideWorkingHours.forEach((function(value, idx) {
        if(value == moment($scope.transport[type].timeStart,'HH:mm').format('HH')){
          inside = 'yes'
        }
      }))
      
      var surcharge = surcharges[`${type}_surcharges`].find(surcharge => surcharge.carriage_surcharge_code == `${code}TIMED` && surcharge.inside_working_hours == inside);
      var formatted_value = (parseInt(moment($scope.transport[type].timeStart,'HH:mm').format('HH')));
      $scope.transport[type].timeEnd = moment(formatted_value,'HH:mm').add(surcharge.duration, 'hours').format('HH:mm');
      $scope.transport[type].option = surcharge;
      $scope.transport['delivery'].timeSlots = [...$scope.insideWorkingHours, ...$scope.outsideWorkingHours];
      $scope.transport['collection'].timeSlots = [...$scope.insideWorkingHours, ...$scope.outsideWorkingHours];

      if(inside == 'no'){
        $scope.transport[type].actual_timeslots = $scope.outsideWorkingHours;
      }
      else {
        $scope.transport[type].actual_timeslots = $scope.insideWorkingHours;
      }

      $scope.transport['delivery'].timeSlots = $scope.transport['delivery'].timeSlots.sort(function(a, b) { return a - b} );
      $scope.transport['collection'].timeSlots = $scope.transport['collection'].timeSlots.sort(function(a, b) { return a - b });

      if(type == 'delivery'){
        var deliveryTimeSlots = $scope.transport['delivery'].timeSlots;
        var collection_formatted_value = (parseInt(moment($scope.transport['collection'].timeStart,'HH:mm').format('HH')));
        var timeSlotLength = $scope.transport['delivery'].timeSlots.length;

        if(deliveryTimeSlots.indexOf(formatted_value) >= deliveryTimeSlots.indexOf(collection_formatted_value) || deliveryTimeSlots.indexOf(formatted_value + 1) >= deliveryTimeSlots.indexOf(collection_formatted_value)){
          var next_index = deliveryTimeSlots.indexOf(formatted_value) + 2;
          if(next_index >= timeSlotLength) next_index = 0;

          $scope.transport['collection'].timeStart = moment((deliveryTimeSlots[next_index]),'HH:mm').format('HH:mm');
          $scope.transport['collection'].timeEnd = moment(deliveryTimeSlots[next_index], 'HH:mm').add(surcharge.duration, 'hours').format('HH:mm')

          var collection_inside = 'no';
          var filteredInsideSlots = $scope.insideWorkingHours;
            // $scope.filterTimeSlots($scope.insideWorkingHours, $scope.transport['collection'].option?.duration || 2);
          filteredInsideSlots.forEach((function(value, idx) {
            if(value == moment($scope.transport['collection'].timeStart,'HH:mm').format('HH')){
              collection_inside = 'yes'
            }
          }))
          var collection_surcharge = surcharges[`collection_surcharges`].find(surcharge => surcharge.carriage_surcharge_code == `COLTIMED` && surcharge.inside_working_hours == collection_inside);
          var collection_value = (parseInt(moment($scope.transport['collection'].timeStart,'HH:mm').format('HH')));
          $scope.transport['collection'].timeEnd = moment(collection_value,'HH:mm').add(collection_surcharge.duration, 'hours').format('HH:mm');
          $scope.transport['collection'].option = collection_surcharge;
          
        }

      }
      
    }
  
      $scope.filterTimeSlots = function(slots,duration){
        var filteredSlots = [];
        //get highest number in array
        var newEnd = slots.slice(-1).pop() - duration;
        //loop through slots and only get numbers lower or equal to new end
        slots.forEach(function(slot) {
          if(slot<=newEnd){
            filteredSlots.push(slot);
          }
        });
      return filteredSlots;
    }
  
    $scope.isOptionValueDisabled = function(value) {
      var deliveryValue = parseInt(moment($scope.transport['delivery'].timeStart,'HH:mm').format('HH')) + 1;
      var collectionValue = parseInt(moment(value,'HH:mm').format('HH'));
  
      var timeslots = $scope.transport['collection'].timeSlots;
      var currentIndex = timeslots.indexOf(deliveryValue);
      var optionIndex = timeslots.indexOf(collectionValue);
  
      if(currentIndex >= optionIndex) return true;
    
      return false;
    }

  }
]);


app.filter('formatSlot', function() {
  return function(slots) {
      var filteredSlots = [];
      //loop through and return addresses with matching postcodes
      angular.forEach(slots, function(slot, key) {
                slot = moment(slot,"HH:mm").format("HH:mm");
                filteredSlots.push(slot);
      });
      return filteredSlots;
  };
});
